import React, { useEffect } from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useDispatch, useSelector } from "react-redux";
import UsersRequests from "services/users";
import ListTableHeading from "./ListTableHeading";
import MListTableHeading from "./MListTableHeading";
import ListTableItem from "./ListTableItem";
import MListTableItem from "./MListTableItem";
import { Box, Typography } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";

const AccessListTable = ({ searchMode, searchInput, isALManamger }) => {
  const dispatch = useDispatch();
  const {
    accessList,
    accessListCurrentPage,
    accessListTotalPages,
    accessManagementList,
    amListCurrentPage,
    amListTotalPages,
  } = useSelector(({ users }) => users);

  useEffect(() => {
    if (isALManamger) {
      if (searchMode) {
        dispatch(UsersRequests.searchAccessMList(1, searchInput));
      } else {
        dispatch(UsersRequests.getAccessMList(1));
      }
    } else {
      if (searchMode) {
        dispatch(UsersRequests.searchAccessList(1, searchInput));
      } else {
        dispatch(UsersRequests.getAccessList(1));
      }
    }
  }, [searchMode, searchInput]);

  const handleChangePagination = (_, value) => {
    if (isALManamger) {
      if (searchMode) {
        dispatch(UsersRequests.searchAccessMList(value, searchInput));
      } else {
        dispatch(UsersRequests.getAccessMList(value));
      }
    } else {
      if (searchMode) {
        dispatch(UsersRequests.searchAccessList(value, searchInput));
      } else {
        dispatch(UsersRequests.getAccessList(value));
      }
    }
  };

  const mainAccessListContent = (
    <>
      {accessList &&
        (accessList.length === 0 ? (
          <Box
            display={"flex"}
            justifyContent={"center"}
            paddingTop={"30px"}
            paddingBottom={"20px"}
          >
            <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
          </Box>
        ) : (
          <Table>
            <TableHead>
              <ListTableHeading />
            </TableHead>
            <TableBody>
              {accessList.map((user) => (
                <ListTableItem user={user} key={user._id} />
              ))}
            </TableBody>
          </Table>
        ))}
      {accessList.length !== 0 ? (
        <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
          <Pagination
            count={accessListTotalPages}
            color="primary"
            page={accessListCurrentPage}
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </>
  );

  const accesslistContent = (
    <>
      {accessManagementList &&
        (accessManagementList.length === 0 ? (
          <Box
            display={"flex"}
            justifyContent={"center"}
            paddingTop={"30px"}
            paddingBottom={"20px"}
          >
            <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
          </Box>
        ) : (
          <Table>
            <TableHead>
              <MListTableHeading />
            </TableHead>
            <TableBody>
              {accessManagementList.map((user) => (
                <MListTableItem user={user} key={user._id} />
              ))}
            </TableBody>
          </Table>
        ))}
      {accessManagementList.length !== 0 ? (
        <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
          <Pagination
            count={amListTotalPages}
            color="primary"
            page={amListCurrentPage}
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </>
  );

  return (
    <div className="Cmt-table-responsive">
      {isALManamger ? accesslistContent : mainAccessListContent}
    </div>
  );
};

export default AccessListTable;
